module.exports = __webpack_public_path__ + "img/netapp.86617b3d.svg";